import { createContext, useContext, useEffect, useMemo, useReducer } from 'react';
import { databaseHandlers, databaseInitialState, databaseReducer } from '../reducers/DatabaseReducer';
import { AppContext } from './AppProvider';
import { useDatabaseFns } from './useHelpers/useDatabaseFns';

export const DatabaseContext = createContext();

const DatabaseProvider = ({ children }) => {

  // appContext
  const appContext = useContext(AppContext)
  const { app_state } = appContext ?? {}
  const { mainDb } = app_state ?? {}

  const init_state = useMemo(() => databaseInitialState({ app_state }), []);
  const [database_state, dispatch] = useReducer(databaseReducer, init_state);
  const { fsdb, appUserDbAccess, useProdDb } = database_state;

  const database_handlers = useMemo(() => databaseHandlers(dispatch), [dispatch]);
  const _database_fns = useDatabaseFns({ fsdb, useProdDb, appUserDbAccess })

  useEffect(() => {
    database_handlers.handleInit_database(app_state);
  }, [database_handlers, app_state]);

  const database_fns = useMemo(() => {
    return _database_fns
  }, [_database_fns])

  if (!database_fns || !mainDb) return null;

  return (
    <DatabaseContext.Provider value={{ database_handlers, database_state, database_fns }}>
      {children}
    </DatabaseContext.Provider>
  );
};

export default DatabaseProvider;
